<template>
  <div class="calculator__calculator-item">
    <div class="calculator__row flex flex--align-center flex--wrap">
      <span class="calculator__label" v-text="item.title"></span>
      <div class="hint" v-if="item.hint">
        <div v-html="item.hint"></div>
      </div>
      <input
        type="text"
        @input="handleFocus(false)"
        min="0"
        step="1"
        v-model="inputValueComputed"
        class="calculator__input"
      />
      <template v-if="item.customSelect">
        <span
          v-html="item.customSelect.textBefore"
          v-if="item.customSelect.textBefore"
        ></span>
        <div class="select" :class="{ active: showCustomSelect }">
          <div
            class="select__head"
            @click="handleSelectHeadClick('custom')"
            ref="customSelectHead"
          >
            <div
              class="select__item select__item--selected"
              v-text="selectValue"
            ></div>
          </div>
          <div class="select__list">
            <template v-for="select in item.customSelect.select">
              <div
                class="select__item"
                @click="
                  (selectValue = select.value), (showCustomSelect = false)
                "
                :key="select.value"
              >
                {{ select.label }}
              </div>
            </template>
          </div>
        </div>
        <span
          style="margin-left: 5px"
          v-html="item.customSelect.textAfter"
        ></span>
      </template>
      <template v-if="item.inputMb">
        <span
          v-html="item.inputMb.textBefore"
          v-if="item.inputMb.textBefore"
        ></span>
        <div class="select" :class="{ active: showSelect }">
          <div
            class="select__head"
            @click="handleSelectHeadClick('mb')"
            ref="head"
          >
            <div
              class="select__item select__item--selected"
              v-text="mbValue"
            ></div>
          </div>
          <div class="select__list">
            <template v-for="select in item.inputMb.select">
              <div
                class="select__item"
                @click="(mbValue = select.value), (showSelect = false)"
                :key="select.value"
              >
                {{ select.label }}
              </div>
            </template>
          </div>
        </div>
        <span style="margin-left: 5px" v-html="item.inputMb.textAfter"></span>
      </template>
    </div>
    <div class="calculator__row calculator__row-slider">
      <div class="calculator__slider-wrapper">
        <div class="background-main"></div>
        <div
          class="background"
          :style="{ width: `calc(${width}% - 13px` }"
        ></div>
        <input
          type="range"
          min="0"
          :max="max"
          step="1"
          v-model="sliderModelComputed"
          @input="handleFocus(true)"
        />
      </div>
      <div
        class="calculator__labels-row flex flex--align-center"
        :style="{ '--items': item.labels.length }"
      >
        <span
          v-for="(label, idx) in item.labels"
          :style="{ '--c': idx }"
          :key="label"
          class="calculator__tick"
          ><div :class="{ 'calculator__tick-hidden': idx % 2 === 1 }">
            {{ handleFormat(label) }}
          </div></span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SliderItem",
  props: ["item"],
  inject: ["closeAllSelects"],
  data() {
    return {
      sliderFocus: false,
      showSelect: false,
      showCustomSelect: false,
      selectValue: this.item?.customSelect?.selectDefault ?? null,
      inputValue: this.item.inputSlider,
      sliderModel: this.handleMaximum(this.item.inputSlider),
      mbValue: this.item?.inputMb?.selectDefault ?? null,
      formatter: Intl.NumberFormat("en", { notation: "compact" }),
    };
  },

  computed: {
    storage() {
      let def = {
        input: this.inputValue,

        key: this.item.title,
      };

      if (this.item.inputMb) {
        def = {
          ...def,
          mb: parseFloat(this.mbValue),
        };
      }

      if (this.item?.customSelect?.select) {
        def = {
          ...def,
          select: this.selectValue,
        };
      }

      return def;
    },
    inputValueComputed: {
      get() {
        return Intl.NumberFormat("en").format(this.inputValue);
      },
      set(val) {
        let normalizeNumber = Math.ceil(this.normalizeNumber(val));
        if (isNaN(normalizeNumber)) normalizeNumber = 0;
        let idx = this.handleMaximum(normalizeNumber);
        this.inputValue = normalizeNumber;
        if (!this.sliderFocus)
          this.sliderModelComputed = idx < 0 ? this.max : idx;
      },
    },
    sliderModelComputed: {
      get() {
        return this.sliderModel;
      },
      set(val) {
        this.sliderModel = val;
        if (this.sliderFocus) this.inputValueComputed = this.item.labels[val];
      },
    },
    max() {
      let items = this.item.labels.length - 1;
      return this.sliderFocus ? items : items * 2;
    },
    width() {
      let w = Math.ceil(((this.sliderModelComputed - 0) * 100) / this.max);
      return w;
    },
  },

  watch: {
    storage: {
      handler() {
        this.$emit("handle-storage", this.storage);
      },
      deep: true,
    },
  },

  methods: {
    closeSelects() {
      this.showSelect = false;
      this.showCustomSelect = false;
    },
    handleSelectHeadClick(type) {
      if (this.closeAllSelects) this.closeAllSelects();
      if (type === "custom") {
        this.showCustomSelect = !this.showCustomSelect;
      } else {
        this.showSelect = !this.showSelect;
      }
    },
    handleFocus(focus) {
      this.sliderFocus = focus;

      if (!focus) {
        let idx =
          this.normalizeNumber(this.inputValueComputed) >
          this.item.labels[this.item.labels.length - 1]
            ? this.max
            : this.handleMaximum(this.inputValueComputed);
        this.sliderModelComputed = idx;
      }

      if (focus) {
        this.sliderModelComputed = this.handleMaximum(this.inputValueComputed);
      }
    },
    handleMaximum(val) {
      let normalize = this.normalizeNumber(val);
      let idx = this.item.labels.findIndex((it) => it >= normalize);
      let labelsVal = this.item.labels[idx];
      if (!this.sliderFocus) {
        idx *= 2;

        if (normalize < labelsVal) {
          idx -= 1;
        }
      }

      return idx;
    },
    handleFormat(num) {
      return this.formatter.format(num);
    },
    normalizeNumber(number) {
      if (typeof number === "string") {
        return parseFloat(number.replaceAll(",", ""));
      }
      return number;
    },
  },
};
</script>

<style lang="scss" scoped>
.select.active {
  position: relative;
  z-index: 100;
}

.calculator__labels-row {
  position: relative;
  margin-top: 10px;
  justify-content: space-between;
  width: 50%;
  --items: 1;

  .calculator__tick {
    position: relative;
    text-align: center;
    font-size: 12px;
    color: #666;
    flex: 1;

    &::before {
      content: "";
      position: absolute;
      top: -22px;
      left: 50%;
      transform: translateX(-50%);
      width: 2px;
      height: 4px;
      background-color: #999;
    }
  }
}
.calculator__labels-row .calculator__tick {
  margin-right: 0px;
}

.calculator__labels-row span:not(:first-child) {
  transform: translateX(0%);
}
.calculator__labels-row {
  margin: 0px;
}
.calculator__tick-hidden {
  visibility: hidden;
}

@media (max-width: 580px) {
  .calculator__labels-row {
    width: 100%;
  }
}

@media (max-width: 450px) {
  .calculator__labels-row .calculator__tick {
    margin-right: -5px;
  }
}
</style>
